export const API_BASE_URL =
  "https://canada-employment-visualization.onrender.com";
